/* currently just a placeholder until we actually do async stuff (coordinate resolving) while cross validating */
export const CrossValidationDisplay = () => {
  return (
    <span>Validating your input and computing derived data...</span>
  )
}